import { FC } from 'react';
import { useCourseListContext } from '@new/common/contexts/CourseListContext';

export const CourseListHeader: FC = () => {
  const { courses, selectedStatus } = useCourseListContext();
  const count = courses[selectedStatus].length;

  return (
    <div className="flex items-center justify-between self-stretch">
      <h4 className="[font-size:var(--fs-h6)]! lg:[font-size:var(--fs-h4)]! text-(--neutral-black-NB1000)! bold m-0!">
        Courses ({count})
      </h4>
    </div>
  );
};
